import { Price } from './Price'
import { RewardPointAmount } from './UserPointRewards'

export enum ServiceOfferOptionBadge {
  FIRST_VISIT_DISCOUNT = 'FIRST_VISIT_DISCOUNT',
  FIRST_TREATMENT_DISCOUNT = 'FIRST_TREATMENT_DISCOUNT',
  PROMOTIONAL_USE_DISCOUNT = 'PROMOTIONAL_USE_DISCOUNT',
  NO_RESTRICTIONS_FOR_DISCOUNT = 'NO_RESTRICTIONS_FOR_DISCOUNT',
}

export enum DiscountEligibility {
  FIRST_VISIT = 'FIRST_VISIT',
  FIRST_TREATMENT = 'FIRST_TREATMENT',
  NO_RESTRICTIONS = 'NO_RESTRICTIONS',
}

export interface DiscountCondition {
  discountEligibility: DiscountEligibility[]
  promotionalUseDiscount: {
    available: boolean
    description: string
  }
}

export interface ServiceOfferOption {
  id: string | null
  name: string
  price: Omit<Price, 'currency'>
  treatments: null | {
    items: AdminTreatmentOption[]
  }
  badges: ServiceOfferOptionBadge[]
  pricePolicy: {
    discountCondition: DiscountCondition
  }
}

export type AdminTreatmentOption = TreatmentOption & {
  id: number | null
  unitProperty: ServiceOfferUnitProperty | null
  priceProperties: {
    items: ServiceOfferPriceProperty[]
  } | null
}

export interface RequestOption {
  id: string | null
  name: string
  price: Pick<Price, 'originalAmount' | 'discountedAmount'>
  treatments: {
    items: AdminTreatmentRequestOption[]
  } | null
  pricePolicy: {
    discountCondition: DiscountCondition
  }
  displayOrder: number
}

export type AdminTreatmentRequestOption = TreatmentOption & {
  id: number | null
  unitProperty?: {
    id: string
    value: number
  }
  priceProperties?: {
    items: {
      id: string
      values: {
        items: {
          id: string
        }[]
      }
    }[]
  }
}

export interface TreatmentOption {
  name: string
  times: {
    value: number
    type: 'NUMBER_OF_TIMES'
  }
  material: {
    name: string
  } | null
}

export type UserTreatmentOption = TreatmentOption & {
  id: string | null
  unitProperty: {
    id: string
    name: string
    value: number
  } | null
  priceProperties: UserServiceOfferUnitProperty[] | null
}

export type UserTreatmentProperty = Omit<TreatmentProperty, 'enabled'>

export type UserServiceOfferUnitProperty = UserTreatmentProperty & {
  values: {
    id: string
    name: string
  }[]
}

export type ServiceOfferUnitProperty = TreatmentProperty & {
  value: number
}

export type ServiceOfferPriceProperty = TreatmentProperty & {
  values: {
    items: {
      id: string
      name: string
    }[]
  }
}

interface TreatmentProperty {
  id: string
  name: string
  enabled: boolean
}

export interface UserServiceOfferOption {
  id: string
  name: string
  price: Price
  treatments: UserTreatmentOption[]
  pointReward: RewardPointAmount | null
  procedureProduct: {
    bundleId: number
  }
  pointAppliedAmount?: number
}
